import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const createNewPositions = async (data) => {
    let config = {
      method: "post",
      url: "employee/api/v1/employee_role_policy/",
      headers: {
        "Content-Type": "application/json",
      },
      data:data
    };
    
    return await axios.create().request(config)
  };
  export const useCreatePositions = () => {
    return useMutation(["announcement-register"], createNewPositions);
  };

  
const getAllPositions = async () => {
  let config = {
    method: "get",
    url: "employee/api/v1/employee_role_policy/",
    headers: {
      "Content-Type": "application/json",
    },
  };
  
  const response = await axios.request(config);
  return response?.data;
};
export const useGetPositionsList = () => {
  return useQuery(["get-all-positions"], getAllPositions);
};


const getPositionsDetail = async (query) => {
  let [, id] = query.queryKey;
  let config = {
    method: "get",
    url: `employee/api/v1/employee_role_policy/${id}/`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  
  const response = await axios.request(config);
  return response?.data;
};
export const useGetPositionsDetail = (id) => {
  return useQuery(["get-positions-by-id", id], getPositionsDetail,{enabled: id?true:false});
};

const positionsUpdate = async (data) => {
  let {id, positions} = data;
  let config = {
    method: "patch",
    url: `employee/api/v1/employee_role_policy/${id}/`,
    headers: {
      "Content-Type": "application/json",
    },
    data: positions,
  };
  return await axios.request(config);
};
export const usePositionsUpdate = () => {
  return useMutation(["positions-update"], positionsUpdate);
};

//API DELETE METHOD
const positionsDeleteById = async (id) => {
  try {
    const response = await axios.delete(`/employee/api/v1/employee_role_policy/${id}/`);
    return response.data;
  } catch (error) {
    // Handle error or throw it again
    throw error;
  }
};

export const usePositionsDeleteById = () => {
  return useMutation(["positions-delete"], positionsDeleteById);
};

